import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { IconButtonSave } from '../../../../../component/IconSvg';
import { CHI_PHI_THUOC_FIELDS, CHI_PHI_THUOC_TYPE } from '../../../../../phan-he-kham-benh/constants/Thuoc';
import PaymentInfor from '../../../../../phan-he-vien-phi/components/PaymentInfor';
import { getFormFieldConfig, getPaymentDetail } from '../../../../../phan-he-vien-phi/services/PhanHeVienPhiServices';
import { CODE } from '../../../../../utils/Constant';
import { usePhanHeDieuTriNoiTruContext } from '../../../../PhanHeDieuTriContext';
import { useKeVatTuContext } from '../../context';

const ChiPhiVatTu = () => {
	const { vatTuChecked } = useKeVatTuContext();
	const [paymentItem, setPaymentItem] = useState<any>([]);
	const { benhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();

	const [thongTinChiPhi, setThongTinChiPhi] = useState<any>({
		tongChiPhi: 0,
		bhyt: 0,
		benhNhan: 0,
		tamUng: 0,
		daThu: 0,
		mienGiam: 0,
		conDu: 0,
	});
	const tongChiPhiVatTu = vatTuChecked.length
		? vatTuChecked.reduce(
			(acc, row) => acc + (row.deleted ? 0 : (row.donGia || 0) * (row.soLuong || 0)),
			0
		)
		: 0;

	const getChiPhiVatTu = (field: CHI_PHI_THUOC_TYPE) => {
		const MAP_FIELD_VALUE = {
			[CHI_PHI_THUOC_FIELDS.TONG_CHI_PHI]: thongTinChiPhi.tongChiPhi + tongChiPhiVatTu,
			[CHI_PHI_THUOC_FIELDS.BHYT]: thongTinChiPhi.bhyt,
			[CHI_PHI_THUOC_FIELDS.NGUON_KHAC]: 0,
			[CHI_PHI_THUOC_FIELDS.BENH_NHAN]:
				thongTinChiPhi.benhNhan + tongChiPhiVatTu - thongTinChiPhi.bhyt,
			[CHI_PHI_THUOC_FIELDS.TAM_UNG]: thongTinChiPhi.tamUng,
			[CHI_PHI_THUOC_FIELDS.DA_THU]: thongTinChiPhi.daThu,
			[CHI_PHI_THUOC_FIELDS.MIEN_GIAM]: thongTinChiPhi.mienGiam,
			[CHI_PHI_THUOC_FIELDS.CON_DU]: thongTinChiPhi.conDu || 0,
		};
		return MAP_FIELD_VALUE[field];
	};

	// Tính còn nợ = Bệnh nhân phải trả - Tạm ứng - Đã thu
	const getConNo = () => {
		return (thongTinChiPhi.benhNhan + tongChiPhiVatTu) - thongTinChiPhi.tamUng - thongTinChiPhi.daThu;
	};

	const handleSetPaymentInfor = async () => {
		const FORM_FIELD_CONFIG = [
			{
				code: "TONG_CHI_PHI",
				name: "Tổng chi phí",
				value: (thongTinChiPhi.tongChiPhi + tongChiPhiVatTu) || 0,
				type: "price",
				color: "text-danger"
			},
			{
				code: "BHYT",
				name: "BHYT",
				value: thongTinChiPhi?.bhyt || 0,
				type: "price",
			},
			{
				code: "NGUON_KHAC",
				name: "Nguồn khác",
				value: 0,
				type: "price",
			},
			{
				code: "BENH_NHAN",
				name: "Bệnh nhân",
				value: (thongTinChiPhi.benhNhan + tongChiPhiVatTu - thongTinChiPhi.bhyt) || 0,
				type: "price",
			},
			{
				code: "TAM_UNG",
				name: "Tạm ứng",
				value: thongTinChiPhi?.tamUng || 0,
				type: "price",
			},
			{
				code: "DA_THU",
				name: "Đã thu",
				value: thongTinChiPhi?.daThu || 0,
				type: "price",
			},
			{
				code: "MIEN_GIAM",
				name: "Miễn giảm",
				value: thongTinChiPhi?.mienGiam || 0,
				type: "price",
			},
			{
				code: "CON_NO",
				name: getChiPhiVatTu('CON_DU') > 0 ? 'Còn dư' : 'Còn nợ',
				value: getChiPhiVatTu('CON_DU') > 0 ? getChiPhiVatTu('CON_DU') : Math.abs(getConNo()) || 0,
				type: "price",
			},
		]
		try {
			let { data: { data } } = await getFormFieldConfig("FORM_INFO_PAYMENT_ASSIGN");
			const jsonObject = JSON.parse(data[0]?.valueText);

			let newArr: any[] = [];
			jsonObject.forEach((item: any) => {
				let obj = FORM_FIELD_CONFIG.find((obj: any) => obj?.code === item);

				newArr.push(obj);
			})

			setPaymentItem(newArr);
		} catch (err) {
			console.error(err);
		}
	};

	const handleGetThongTinChiPhi = async () => {
		try {
			const { data } = await getPaymentDetail(benhNhanDieuTri?.visitId);
			if (CODE.SUCCESS === data?.code) {
				setThongTinChiPhi({
					tongChiPhi: data?.data?.ttTong,
					bhyt: data?.data?.ttBhyt,
					benhNhan: data?.data?.ttNguoiBenh,
					tamUng: data?.data?.ttTamUng,
					daThu: data?.data?.ttDaThu,
					mienGiam: data?.data?.ttDiscountInv,
					conDu: data?.data?.ttConNo,
				});
			}
		} catch (error) {
			console.error(error);
			toast.error('Xảy ra lỗi khi lấy thống tin chi phi, vui lòng thử lại!');
		}
	}

	useEffect(() => {
		handleGetThongTinChiPhi();
	}, []);

	useEffect(() => {
		handleSetPaymentInfor();
	}, [tongChiPhiVatTu, thongTinChiPhi]);

	return (
		<div className="d-flex justify-content-between align-items-center spaces p-10 mt-6 bg-white w-100">
			<PaymentInfor
				className="w-100 price-info"
				paymentData={paymentItem}
			/>
			<Button className="btn-fill spaces min-w-100" type="submit">
				<IconButtonSave /> Lưu
			</Button>
		</div>
	);
};

export default ChiPhiVatTu;
